import React, { Fragment, FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import Table, {
  TableHeader,
  TableRow,
} from '@bitcoin-portal/verse-web-components/dist/Table';

import { LoadingView } from '@components/LoadingView';

import { USDT_WZANO_FARM } from '@context/constants';
import { useFarms } from '@context/providers/FarmsProvider';

import InvestmentRow from './InvestmentRow';
import MobileRow from './MobileRow';
import { ButtonHeader, FarmsHeader, MobileTable, TableWrapper } from './styled';

interface Props {
  setFarm: (farm: IFarmPair) => void;
  onConnectWallet?: () => void;
}

export const InvestmentsList: FunctionComponent<Props> = ({
  setFarm,
  onConnectWallet,
}) => {
  const { farmBalances, farmPairs: pairs } = useFarms();

  const shouldShowFarm = (farm: IFarmPair): boolean => {
    if (!farmBalances) return false;
    const isWzanoFarm = farm.contractAddress === USDT_WZANO_FARM;
    const balance = farmBalances[farm.contractAddress];
    return isWzanoFarm ? balance?.gt(0) : true;
  };

  return !pairs.length ? (
    <LoadingView style={{ width: 1000 }} />
  ) : (
    <>
      <TableWrapper>
        <Table>
          <thead>
            <TableRow>
              <FarmsHeader>
                <FormattedMessage id="farms.list.farm" />
              </FarmsHeader>
              <TableHeader style={{ textAlign: 'left' }}>
                <FormattedMessage id="farms.list.apy" />
              </TableHeader>
              <TableHeader style={{ textAlign: 'left' }}>
                <FormattedMessage id="farms.list.deposits" />
              </TableHeader>
              <TableHeader
                style={{
                  textAlign: 'left',
                  paddingRight: '40px',
                }}
              >
                <FormattedMessage id="farms.list.rewards" />
              </TableHeader>
              <ButtonHeader />
            </TableRow>
          </thead>
          <tbody>
            {pairs
              .filter((farm: IFarmPair) => shouldShowFarm(farm))
              .map((farm: IFarmPair) => {
                if (farm.singleSided) return null;
                return (
                  <Fragment key={farm.contractAddress}>
                    <InvestmentRow
                      farm={farm}
                      setFarm={setFarm}
                      onConnectWallet={onConnectWallet}
                    />
                  </Fragment>
                );
              })}
          </tbody>
        </Table>
      </TableWrapper>
      <MobileTable>
        {pairs
          .filter((farm: IFarmPair) => shouldShowFarm(farm))
          .map((farm: IFarmPair) => {
            if (farm.singleSided) return null;
            return (
              <Fragment key={farm.contractAddress}>
                <MobileRow
                  farm={farm}
                  setFarm={setFarm}
                  onConnectWallet={onConnectWallet}
                />
              </Fragment>
            );
          })}
      </MobileTable>
    </>
  );
};

export default InvestmentsList;
